import { createEntityAdapter, EntityState } from "@ngrx/entity";
import { createReducer, on } from "@ngrx/store";
import { GuardianApiActions } from "../actions/action-index";
import { Guardian } from "./guardian";

export const featureKey = "guardians";

export type GuardianState = EntityState<Guardian>

export const adapter = createEntityAdapter<Guardian>({
  selectId: (guardian) => guardian.id,
  sortComparer: (a, b) => a.name.localeCompare(b.name),
});

export const initialState: GuardianState = adapter.getInitialState();

export const reducer = createReducer(
  initialState,
  on(GuardianApiActions.loadSuccess, (state, { guardians }) =>
    adapter.setAll(
      guardians.map((g) => ({
        firstName: g.FirstName,
        id: g.GuardianId,
        lastName: g.LastName,
        name: `${g.FirstName} ${g.LastName}`,
      })),
      state
    )
  )
);
